import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PaymentMethod } from '../../models/payment-method.model';

export const PaymentMethodsActions = createActionGroup({
  source: 'Payment Method',
  events: {
    'Start Loading Post Payment Method': emptyProps(),
    'Start Loading Delete Payment Method': emptyProps(),
    'Add PaymentMethod': props<{ paymentMethod: PaymentMethod }>(),
    'Delete Payment Method': props<{ paymentId: string }>(),
  },
});

export const PaymentMethodsApiActions = createActionGroup({
  source: 'Payment Methods API',
  events: {
    'Fetch Payment Methods': emptyProps(),
    'Retrieved Payment Methods': props<{
      paymentMethods: ReadonlyArray<PaymentMethod>;
    }>(),
    'Post Payment Method': props<{ paymentId: string }>(),
    'Posted Payment Method': props<{ paymentMethod: PaymentMethod }>(),
    Failed: props<{ errorMessage: string }>(),
  },
});
